import { useContext } from 'react';

import OrdersContext from './OrdersContext';

const useOrders = () => useContext(OrdersContext);

export default useOrders;
